import { applySeo } from "../lib/seo";
import { useEffect } from "react";
import { PRIVACY } from "../data/site";
import { Reveal } from "../components/site/Reveal";

export default function Privacy() {
  useEffect(() => {
    applySeo({ paths: ["/privacy-policy/"], fallbackTitle: "Privacy Policy | Cedar Views" });
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="privacy-page" className="pt-32 pb-24 max-w-3xl mx-auto px-6">
      <Reveal>
        <p className="overline-x mb-6">Legal</p>
        <h1 className="font-display tracking-tighter text-4xl sm:text-5xl text-white" style={{ fontWeight: 800 }}>{PRIVACY.title}</h1>
        <div className="mt-10 space-y-6 text-white/60 leading-relaxed text-[15px]">
          {PRIVACY.paragraphs.map((para, i) => <p key={i}>{para}</p>)}
        </div>
      </Reveal>
    </main>
  );
}
